export default "__VITE_ASSET__vhnhTxEi__"